<template>
	<div>
		<div class="timeline_row" v-for="(incident, index) in incidents" :key="index">
			<div class="timeline_left">
				<div class="timeline_name" v-if="incident.team === 'home'">
					<div v-if="incident.players.main">
						{{ incident.players.main.name }}
						<div v-if="incident.incedent_name === 'Penalty shootout scored'">(Пенальти)</div>
						<div v-if="incident.incedent_name === 'Penalty shootout missed' || incident.incedent_name === 'Missed penalty'">(Незабитый пенальти)</div>
						<div v-if="incident.players.assist">({{incident.players.assist.name}})</div>
					</div>
					<div v-else>
						<div class="timeline_name __color-1">{{ incident.players.in.name }}</div>
						<div class="timeline_name __color-2">{{ incident.players.out.name }}</div>
					</div>
				</div>
				<div class="timeline_time" v-if="incident.team === 'away' && !incident.penalty">{{ incident.time }}'</div>
			</div>
			<div class="timeline_center">
				<div class="timeline_cart __yellow" v-if="incident.incedent_name === 'Yellow card'"></div>
				<div class="timeline_cart __yellow __yellow-2" v-if="incident.incedent_name === 'Yellow card 2'"></div>
				<div class="timeline_cart __red" v-if="incident.incedent_name === 'Red card'"></div>
				<div class="timeline_warning" v-if="incident.incedent_name === 'Missed penalty' || incident.incedent_name === 'Penalty shootout missed'"></div>
				<div class="timeline_ball" v-else-if="incident.incedent_type === 'goal'"></div>
				<div class="timeline_arrow" v-if="incident.incedent_type === 'subst'">
					<div class="timeline_arrow-up"></div>
					<div class="timeline_arrow-down"></div>
				</div>
			</div>
			<div class="timeline_right">
				<div class="timeline_name" v-if="incident.team === 'away'">
					<div v-if="incident.players.main">
						{{ incident.players.main.name }}
						<div v-if="incident.incedent_name === 'Penalty shootout scored'">(Пенальти)</div><div v-if="incident.incedent_name === 'Penalty shootout missed' || incident.incedent_name === 'Missed penalty'">(Незабитый пенальти)</div>
						<div v-if="incident.players.assist">({{incident.players.assist.name}})</div>
					</div>
					<div v-else>
						<div class="timeline_name __color-1">{{ incident.players.in.name }}</div>
						<div class="timeline_name __color-2">{{ incident.players.out.name }}</div>
					</div>
				</div>
				<div class="timeline_time" v-if="incident.team === 'home' && !incident.penalty">{{ incident.time }}'</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['incidents'],
	}
</script>

<style scoped>

</style>